import {
  type WhereFilterOp,
  collection,
  limit,
  orderBy,
  query,
  startAfter,
  where,
} from "firebase/firestore";

import {firestore} from "~/firebase/firebase";

type NestedKeys<T, Prefix extends string = ""> = {
  [K in Extract<keyof T, string>]: NonNullable<T[K]> extends object
    ? NonNullable<T[K]> extends (...args: any) => any
      ? never
      : `${Prefix}${K}` | NestedKeys<NonNullable<T[K]>, `${Prefix}${K}.`>
    : NonNullable<T[K]> extends (...args: any) => any
      ? never
      : `${Prefix}${K}`;
}[Extract<keyof T, string>];

export type Filter<T> = {
  fieldPath: NestedKeys<T>;
  opStr: WhereFilterOp;
  value: any;
};

export type Sort<T> = {fieldPath: NestedKeys<T>; direction: "asc" | "desc"};

export type QueryOptions<T> = {
  filters?: Filter<T>[];
  sort?: Sort<T>[];
  limit?: number;
  // New composite cursor option.
  startAfterValues?: any[];
};

export function buildQuery<T>(
  collectionPath: [string, ...string[]],
  options: QueryOptions<T>,
) {
  const collectionRef = collection(firestore, ...collectionPath);
  let q = query(collectionRef);

  // Apply filters
  if (options.filters) {
    options.filters.forEach((filter) => {
      q = query(
        q,
        where(filter.fieldPath as string, filter.opStr, filter.value),
      );
    });
  }

  // Apply sorting
  if (options.sort) {
    options.sort.forEach((sortOption) => {
      q = query(
        q,
        orderBy(sortOption.fieldPath as string, sortOption.direction),
      );
    });
  }

  // Apply composite cursor
  if (options.startAfterValues) {
    q = query(q, startAfter(...options.startAfterValues));
  }

  // Apply limit
  if (options.limit) {
    q = query(q, limit(options.limit));
  }
  return q;
}
